import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubMenuCurriculumWrapper from "Administrator/commonComponents/SubMenuCurriculumWrapper";
export default store => ({
  path: "family-members",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-family-members" */ "../../../ManageFamily/components"
        ),
        import(
          /* webpackChunkName: "course-family-members" */ "../../../ManageFamily/modules/ManageFamilyModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "family-members",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [SubMenuCurriculumWrapper(store)],
});
